var quiz = {
    title: 'Semway Gamification',
    questions: [
      {
        text: "Hva står SEO for?",
        responses: [
          {text: 'Service elevator operator', value: 4, points: 1},
          {text: 'Search engine optimization', value: 3},
          {text: 'Search engeneer operator', value: 2},
          {text: 'Search engine octopus', value: 1},
        ]
      },{
        text: "Hva står SEO for?",
        responses: [
          {text: 'Service elevator operator', value: 4, points: 1},
          {text: 'Search engine optimization', value: 3},
          {text: 'Search engeneer operator', value: 2},
          {text: 'Search engine octopus', value: 1},
        ]
      }, {
        text: "Har du en hobby eller interesse som du dedikerer mye tid til?",
        responses: [
          {text: 'Prøver å dyrke hobbyen daglig.', value: 4},
          {text: 'Voksenlivet gjør det mer krevende enn før, men jeg prøver å få det til ukentlig.', value: 3},
          {text: 'Har flere hobbyer, men ingen jeg bruker særlig mye tid på.', value: 2},
          {text: 'Jeg har ingen særlige interesser.', value: 1},
        ]
      }, {
        text: "Dropper du ofte uteliv til fordel for brettspillkvelder, Star Wars-maraton eller dyrking av hobbyen din?",
        responses: [
          {text: 'Helst hver helg.', value: 4},
          {text: 'Så ofte husstanden tillater det.', value: 3},
          {text: '3–4 helger i året.', value: 2},
          {text: 'Har aldri helt skjønt meg på de greiene der.', value: 1},
        ]
      }, {
        text: "Spør kolleger deg ofte til råds om svært spesifikke tema?",
        responses: [
          {text: 'Skulle jeg besvart alle spørsmålene, hadde jeg ikke hatt tid til egne prosjekter.', value: 4},
          {text: 'Jeg er som regel den som må spørre kolleger om råd.', value: 2},
          {text: 'Jeg får relativt ofte henvendelser og bistår der jeg kan, men i blant må også jeg spørre andre.', value: 3},
          {text: 'Jeg har ikke så mye detaljkunnskap.', value: 1},
        ]
      }, {
        text: "Du møter en utfordring i et prosjekt som du ikke har vært borti før. Hva gjør du?",
        responses: [
          {text: 'Går til sjefen og sier at dette prosjektet ikke er noe for deg.', value: 1},
          {text: 'Søker iherdig etter tutorials og diskusjonsforaer på nettet, og gir deg ikke før du har funnet en løsning.', value: 4},
          {text: 'Du har en fast kollega du kan spørre om råd når slike utfordringer oppstår.', value: 2},
          {text: 'Du bygger en egen kode, løsning eller et system som du tilpasser til programvarer og veiledere, som løser problemet.', value: 4},
        ]
    },
  ]
};
  
export default quiz;


// WEBPACK FOOTER //
// ./src/appdata/quiz.js